import * as React from 'react';

export const noDefault     = eventWrapper(e => e.preventDefault());
export const noPropagation = eventWrapper(e => e.stopPropagation());

function eventWrapper(aspect : (e : React.SyntheticEvent<any>) => void) {
    return <E extends React.SyntheticEvent<any>>(action : (e : E) => void) => (e : E) => {
        aspect(e);
        action(e);
    };
}


// WEBPACK FOOTER //
// ./lib/eventWrappers.ts